import { CarouselProps, Carousel as MantineCarousel } from '@mantine/carousel';
import '@mantine/carousel/styles.css';
import Autoplay from 'embla-carousel-autoplay';

import classes from './Carousel.module.css';

const Carousel = (props: CarouselProps) => {
  return (
    <MantineCarousel
      classNames={{
        indicator: classes.indicator,
        indicators: classes.indicators,
      }}
      {...props}
    />
  );
};

const CarouselWithSlide = Carousel as typeof MantineCarousel;
CarouselWithSlide.Slide = MantineCarousel.Slide;

export { CarouselWithSlide as Carousel, Autoplay as CarouselAutoplay };
